import React from 'react';
import { config } from '@uhg-abyss/web/tools/config';
import { useDashboard } from '@src/state/dashboard';
import { MediaQuery } from '@uhg-abyss/web/ui/MediaQuery';
import { styled } from '@uhg-abyss/web/tools/styled';
import { getFeature } from '@sde/widgets-core/src/redux/tools/features';
import { usePPDLagoon } from '@sde/widgets-core/src/tools/lagoon';
import { useUser } from '@sde/widgets-core/src/redux/resources/user';
import { IconMaterial } from '@uhg-abyss/web/ui/IconMaterial';
import { MyAccount } from './MyAccount';
import { TrackItTopBar } from './TrackItTopBar';
import { TopBarDropdownContent } from './TopBarDropdownContent';

const ZIndexDiv = styled('div', {
  zIndex: 1250,
});

const StyledFlexDiv = styled('div', {
  display: 'flex',
  gap: '5px',
  alignItems: 'center',
});

export const TopBar = () => {
  const { user } = useUser.state();
  const { getHeaderContents } = usePPDLagoon();

  const { openTrackItFlyout } = useDashboard.actions();

  const practiceManagement = getHeaderContents('topBar', 'practiceManagement');

  const trainingSupport = getHeaderContents('topBar', 'trainingSupport');

  const topBarArray = [];

  const trainingSupportHeaderObject = getFeature('TRAINING_AND_SUPPORT_SECTION')
    ? {
        title: (
          <div data-testid='training-and-support-link'>Training & Support</div>
        ),
        content: <TopBarDropdownContent contents={trainingSupport} />,
      }
    : {
        title: (
          <StyledFlexDiv data-testid='Help-link'>
            <IconMaterial size='16px' icon='help' color='$interactive1' />
            Help
          </StyledFlexDiv>
        ),
        href: config('PROVIDER_SELF_SERVICE_URL'),
      };
  topBarArray.push(trainingSupportHeaderObject);

  if (getFeature('MANAGE_PRACTICE_SECTION')) {
    topBarArray.push({
      title: (
        <div data-testid='practice-management-link'>Practice Management</div>
      ),
      content: <TopBarDropdownContent contents={practiceManagement} />,
    });
  }

  if (getFeature('TRACKIT_OVERALL')) {
    topBarArray.push({
      title: (
        <React.Fragment>
          <MediaQuery largerThan={984}>
            <TrackItTopBar abyssHeaderStyle='navButton' />
          </MediaQuery>
          <MediaQuery smallerThan={984}>
            <TrackItTopBar abyssHeaderStyle='navButtonCollapsed' />
          </MediaQuery>
        </React.Fragment>
      ),
      onClick: () => openTrackItFlyout(true),
    });
  }
  const myAccountHeaderObject = {
    title: (
      <StyledFlexDiv
        data-testid='user-firstName-link'
        data-cy='profile-and-setting-dropdown-btn'
      >
        <IconMaterial icon='account_circle' />
        {user.firstName}
      </StyledFlexDiv>
    ),
    content: (
      <ZIndexDiv>
        <MyAccount />
      </ZIndexDiv>
    ),
  };
  topBarArray.push(myAccountHeaderObject);

  return topBarArray;
};
